import { Phone, Mail, MapPin, ArrowUp } from "lucide-react";
import { SITE, NAV_LINKS } from "@/lib/site-data";

export default function Footer() {
  const goTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-luxe-black border-t border-white/10 pt-20 pb-8 overflow-hidden"
    >
      {/* Top accent */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#385723] to-transparent" />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Big logo statement */}
        <div className="border-b border-white/10 pb-12 mb-12">
          <h2 className="heading-xl text-5xl sm:text-7xl lg:text-8xl text-white/90 leading-none">
            DISEÑO &
            <br />
            <span className="text-[#385723]">CONSTRUCCIÓN</span> LUXE.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          {/* About */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <img
                src="/assets/luxe-logo.png"
                alt="DISEÑO Y CONSTRUCCIÓN LUXE"
                className="h-16 w-auto object-contain"
                style={{ filter: "invert(1)" }}
              />
              <div className="border-l border-white/15 pl-4">
                <span className="font-heading font-bold text-white tracking-widest uppercase block leading-none">
                  Construcción Luxe
                </span>
                <span className="font-body text-[10px] text-[#767171] tracking-[0.25em] uppercase mt-1 block">
                  Diseño · Ingeniería
                </span>
              </div>
            </div>
            <p className="font-body text-white/60 leading-relaxed max-w-sm mb-6">
              Soluciones llave en mano de ingeniería civil, arquitectura y construcción de lujo.
              Zapopan, Jalisco · México.
            </p>
            <div className="flex items-center gap-3">
              <span className="overline">{SITE.tagline}</span>
            </div>
          </div>

          {/* Quick links */}
          <div className="md:col-span-3">
            <h4 className="font-heading text-xs uppercase tracking-[0.25em] text-[#767171] mb-5">
              Navegación
            </h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      const id = link.href.replace("#", "");
                      document
                        .getElementById(id)
                        ?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="font-body text-sm text-white/80 hover:text-[#385723] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="font-heading text-xs uppercase tracking-[0.25em] text-[#767171] mb-5">
              Contacto
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#385723] mt-1 flex-shrink-0" strokeWidth={1.5} />
                <a
                  href={`tel:${SITE.phoneRaw}`}
                  className="font-body text-sm text-white/80 hover:text-white"
                >
                  {SITE.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#006961] mt-1 flex-shrink-0" strokeWidth={1.5} />
                <a
                  href={`mailto:${SITE.email}`}
                  className="font-body text-sm text-white/80 hover:text-white break-all"
                >
                  {SITE.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#385723] mt-1 flex-shrink-0" strokeWidth={1.5} />
                <span className="font-body text-sm text-white/80 leading-relaxed">
                  {SITE.address}
                  <br />
                  {SITE.city} · {SITE.cp}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-[#767171]">
            © {new Date().getFullYear()} {SITE.name}. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            <span className="font-heading text-xs uppercase tracking-[0.25em] text-[#767171]">
              {SITE.website}
            </span>
            <button
              onClick={goTop}
              data-testid="back-to-top-button"
              aria-label="Subir al inicio"
              className="w-10 h-10 border border-white/20 flex items-center justify-center text-white/70 hover:bg-[#385723] hover:border-[#385723] hover:text-white transition-colors"
            >
              <ArrowUp className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
